
import mapsCN from '../lang/cn/map';
import mapsEN from '../lang/en/map';

const lang = window.lang ? window.lang : 'cn';
const langObj = { cn: mapsCN, en: mapsEN };

const mapsFun = (key, value) => {
    if (value === undefined) {
        return langObj[lang][key];
    } else if (langObj[lang][key]) {
        return langObj[lang][key][value] || '';
    }

    return '';
};

export { mapsFun as default };

